import styled from 'styled-components';
import { Box } from '@scope/scope-one-ui/core';
import { COLORS, SIZES } from '@scope/scope-one-ui/theme';

export const VerticalArrowContainer = styled.div`
  display: flex;
  background-color: ${COLORS.background.main};
  border-top: 1px solid ${COLORS.border.main};
  border-bottom: 1px solid ${COLORS.border.main};
`;

export const VerticalPolygon = styled.div`
  height: 100%;
  flex-shrink: 0;
  width: ${SIZES.spacing(6.25)};
`;

export const VerticalArrowBorderLeft = styled(VerticalPolygon)`
  background-color: ${COLORS.border.main};
  margin-left: -${SIZES.spacing(2.5)};
  clip-path: polygon(38% 0, 40% 0, 100% 50%, 40% 100%, 38% 100%, 98% 50%);
`;

export const VerticalArrow = styled(VerticalPolygon)`
  background-color: ${COLORS.background.control};
  margin-left: -${SIZES.spacing(3.75)};
  clip-path: polygon(0 0, 40% 0, 100% 50%, 40% 100%, 0 100%, 60% 50%);
  margin-top: -1px;
  height: calc(100% + 2px);
`;

export const VerticalArrowBorderRight = styled(VerticalPolygon)`
  background-color: ${COLORS.border.main};
  margin-left: -${SIZES.spacing(6.125)};
  clip-path: polygon(38% 0, 40% 0, 100% 50%, 40% 100%, 38% 100%, 98% 50%);
`;

export const SentimentScore = styled(Box)`
  background-color: ${COLORS.background.main};
  border: 1px solid ${COLORS.border.main};
  border-right: 0;
  width: ${SIZES.spacing(46)};
  height: ${SIZES.spacing(48)};

  & > div {
    box-sizing: content-box;
    color: ${COLORS.typography.main};
  }
`;

export const SentimentBreakdown = styled(Box)`
  background-color: ${COLORS.background.main};
  border: 1px solid ${COLORS.border.main};
  border-left: 0;
  min-width: ${SIZES.spacing(60)};
  height: ${SIZES.spacing(48)};
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
`;

export const SentimentCharts = styled(Box)`
  display: flex;
  flex: 1;
  justify-content: center;
  grid-gap: ${SIZES.spacing(2)};
  & > div {
    box-sizing: content-box;
    color: ${COLORS.typography.main};
  }
`;

export const SentimentHeader = styled(Box)`
  display: flex;
  justify-content: center;
  grid-gap: ${SIZES.spacing(28)};
`;

export const VerticalDivider = styled(Box)`
  width: 1px;
  background-color: ${COLORS.border.main};
  margin-top: ${SIZES.spacing(-6)};
`;
